
import React from 'react'
import { useEffect } from 'react';
import Helper from '../components/Helper';
import {  APPLICATION_JSON } from '../middleware/types';





function Preview(props) {

    const [showDateForm, setShowDateForm] = React.useState(false)
    const [dateValue, setDateValue] = React.useState("");
    const [showPreviewDate, setShowPreviewDate] = React.useState(false)
    const [getPreviewDate, setGetPreviewDate] = React.useState("");

    useEffect(() => {
        if (window.location.hostname.startsWith("preview")) {
            setShowPreviewDate(true)
        }
    }, [setShowDateForm])

    const switchDateEdit = (event) => {
        setShowDateForm(true)
    }
    const switchDateEditClose = (event) => {
        setShowDateForm(false)
    }
    function handleDateUpdate(event) {
        setDateValue(event.target.value)
    }
    async function handlePreviewDate(event) {
        var urlPath = window.location.origin
        var src = window.location.search.replace('?', '')
        var pageURL = urlPath + "/" + src
        var Url = `${pageURL}/set-preview-date?previewDate=${dateValue}`
        var response = await Helper.fetchCallFunction(Url, "GET", false, "", JSON.stringify({  }))
        if(response){
        window.location.reload();
        }
        
    }
    useEffect(()=>{
        var urlPath = window.location.origin
        var src = window.location.search.replace('?', '')
        var pageURL = urlPath + "/" + src
if (window.location.hostname.startsWith("preview")) {
        var url = `${pageURL}/get-preview-date`
        fetch(url)
                .then((res) => res.json())
                .then((res) => {
                    setGetPreviewDate(res.previewDate2)
                });
            }
    },[])
    return (
        <>
            {showPreviewDate ?
                <>
                    {showDateForm === false ? <div className="d-flex justify-content-center" style={{ height: '3rem', backgroundColor: '#acacac', paddingTop: '0.5rem', cursor: 'pointer', zIndex: 2000, position: "relative" }} onClick={switchDateEdit}>
                        <h5>PREVIEW DATE : {getPreviewDate}</h5>
                    </div>
                        :
                        <div className="d-flex justify-content-center" style={{ padding: '0.5rem', zIndex: 2000, position: "relative" }}>
                            <input type="date" name="previewDate" onChange={(e) => handleDateUpdate(e)}></input>
                            <button className="btn btn-primary mx-4" style={{ fontSize: "11px", backgroundColor: "#35649A", color: "#fff",  }} onClick={handlePreviewDate}>Submit</button>
                            <button className="btn btn-danger" style={{ fontSize: "11px" }} onClick={switchDateEditClose}>Cancel</button>
                        </div>
                    }
                </> : ""}

            {/* <iframe width="100%" height="100%" src={pageURL} className='iframe-cont'></iframe> */}
        </>)
}

export default Preview

